import { render, staticRenderFns } from "./DeductionImpactDialog.vue?vue&type=template&id=27cdf8aa&scoped=true&"
import script from "./DeductionImpactDialog.vue?vue&type=script&lang=js&"
export * from "./DeductionImpactDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeductionImpactDialog.vue?vue&type=style&index=0&id=27cdf8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cdf8aa",
  null
  
)

export default component.exports